import { useNavigate } from 'react-router-dom';

import cookiePolicyMarkdown from '../../legal-documents/cookie-policy.md?raw';
import LegalDocumentPage from './legal-document-page';

const CookiePolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/dashboard', { replace: true });
    }
  };

  return <LegalDocumentPage markdown={cookiePolicyMarkdown} onBack={handleBack} />;
};

export default CookiePolicy;
